@if (loaderService.loading$ | async) {
  <div class="loader">
    <div class="justify-content-center jimu-primary-loading"></div>
  </div>
}
